module.exports = __webpack_public_path__ + "img/swiper_3.0_2_2.43ac9416.webp";